import * as React from 'react';
import { useEffect, useState } from 'react';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function BackToTopButton() {
    const [showBackToTop, setShowBackToTop] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Show back to top button when scrolled down
    useEffect(() => {
        const handleScroll = () => {
            setShowBackToTop(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!showBackToTop) {
        return null;
    }

    return (
        <Fab
            color="primary"
            size="medium"
            onClick={scrollToTop}
            sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                backgroundColor: '#FF5722',
                '&:hover': {
                    backgroundColor: '#FF5722'
                }
            }}
        >
            <KeyboardArrowUpIcon />
        </Fab>
    );
}

export default BackToTopButton;
